import { QueryClient } from '@tanstack/vue-query'

export default new QueryClient()
